import { createVNode as n, mergeProps as o } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CalendarOutlined.js";
import i from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return n(i, o(a, {
    icon: l
  }), null);
};
r.displayName = "CalendarOutlined";
r.inheritAttrs = !1;
export {
  r as default
};
